"use strict";
angular.module('newspaperSampleUploadModule', []).
controller('newspaperSampleUploadCtrl', ["$scope", "$q", "$filter", "$stateParams", "modalDialog", "editNewspaperService", "trsHttpService", "localStorageService", "$state", "storageListenerService",
    function($scope, $q, $filter, $stateParams, modalDialog, editNewspaperService, trsHttpService, localStorageService, $state, storageListenerService) {
        initStatus();
        initData();

        function initStatus() {
            $scope.data = {
                selectedArray: [],
                ALLitems: []
            };
        }


        function initData() {
            localStorageService.set("newspaperDY", "doing");
        }

        /**
         * [singleSelecte description]单选
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.singleSelected = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index > -1) $scope.data.selectedArray.splice(index, 1);
            else {
                $scope.data.selectedArray.push(item);
            }
        };


        /**
         * [reRresh description] 更新页面数据
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.reRresh = function(item) {
            if (typeof(item.id) == 'undefined') {
                item.id = $scope.data.ALLitems.length;
                $scope.data.ALLitems.push(item);
            } else { //编辑
                $scope.data.ALLitems[item.id] = item;
            }
        };


        /** [manualUpload description]手动上传大眼审阅图片 */
        $scope.manualUpload = function() {
            editNewspaperService.manualUpload($stateParams.paperid, "", $scope.reRresh);
        };

        $scope.delete = function() {
            if ($scope.data.selectedArray == 0) {
                return;
            }
            var content = "确认删除" + $scope.data.selectedArray[0].diePosition + "-" + $scope.data.selectedArray[0].banPositon;
            if ($scope.data.selectedArray.length > 1) {
                content += "等版面";
            } else {
                content += "版面";
            }
            modalDialog.confirmModal('删除', content, function() {
                for (var i = 0; i < $scope.data.selectedArray.length; i++) {
                    var item = $scope.data.selectedArray[i];
                    for (var j = $scope.data.ALLitems.length - 1; j >= 0; j--) {
                        if (item.id == $scope.data.ALLitems[j].id) {
                            $scope.data.ALLitems.splice(j, 1);
                            modalDialog.alertType("删除成功！", "", "success", false);
                        }
                    }
                }
                $scope.data.selectedArray = [];
            });
        };

        /**
         * [singleDelete description] 单个删除
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.singleDelete = function(item) {
            var content = "确认删除" + item.diePosition + "-" + item.banPositon + "版面";
            modalDialog.confirmModal('删除', content, function() {
                var index = $scope.data.ALLitems.indexOf(item.id);
                $scope.data.ALLitems.splice(index, 1);
                $scope.data.selectedArray = [];
                modalDialog.alertType("删除成功！", "", "success", false);
            });

        };

        $scope.edit = function(item) {
            editNewspaperService.manualUpload($stateParams.paperid, item, $scope.reRresh);
        };
        //全选框 点击选中
        $scope.selectAll = function() {
            if ($scope.data.selectedArray.length == $scope.data.ALLitems.length) {
                $scope.data.selectedArray = [];
            } else {
                $scope.data.selectedArray = [].concat($scope.data.ALLitems);
            }
        };

        $scope.upload = function() {
            if ($scope.data.ALLitems.length < 1) {
                return;
            }
            var params = {
                serviceid: "mlf_dymonitor",
                methodname: "saveDaYang",
                PAPERID: $stateParams.paperid,
                PICTURE: []
            };
            var singleImg = {};
            for (var i = 0; i < $scope.data.ALLitems.length; i++) {
                var item = $scope.data.ALLitems[i];
                singleImg = {
                    "imageName": item.imageName,
                    "zhuBanName": item.zuPeople,
                    "orignalImg": item.orignalImg,
                    "pubTime": $filter("date")(item.time, "yyyy-MM-dd"),
                    "banmianID": item.banPositonId,
                    "dieciID": item.diePositionId
                };
                params.PICTURE.push(singleImg);
            }
            params.PICTURE = JSON.stringify(params.PICTURE);
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                console.log(data);
                localStorageService.set("newspaperDY", "done");
                // window.close();
            });
        };
        /**
         * [toDetail description]  大样预览
         * @param  {[type]} imgSrc [description] 图片地址
         * @return {[type]}        [description]
         */
        $scope.toDetail = function(item) {
            storageListenerService.previewPageTurningStorage($scope.data.ALLitems, "imgSrc,diePosition,banPositon", "newspaperDYPreview");
            var href = $state.href("newspapersampledetail", {src: encodeURIComponent(item.imgSrc),diePosition:item.diePosition,banPositon:item.banPositon});
            window.open(href);
        };

    }
]);